import { render, staticRenderFns } from "./Selfie.vue?vue&type=template&id=8a3f9ed0&scoped=true&"
import script from "./Selfie.vue?vue&type=script&lang=js&"
export * from "./Selfie.vue?vue&type=script&lang=js&"
import style0 from "./Selfie.vue?vue&type=style&index=0&id=8a3f9ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3f9ed0",
  null
  
)

export default component.exports